import Keycloak from "keycloak-js";
import getEnv from "./config";

const host = getEnv("REACT_APP_KEYCLOAK_HOST").replace(/\/+$/, "");
const realm = getEnv("REACT_APP_KEYCLOAK_REALM", "M4D-CTI");
const clientId = getEnv("REACT_APP_KEYCLOAK_CLIENT_PUBLIC", "cti-public-client");

const keycloak = new Keycloak({
  url: host,
  realm: realm,       // CTI
  clientId: clientId, // misp-client-public
});

export default keycloak;
